import apiClient from './client'
import { apiEndpoints } from '@/config/api'

/**
 * Inquiries API
 * 
 * All endpoints use the base URL from VUE_APP_API_URL environment variable
 * Default: https://inversuncms.on-forge.com/api
 */

export const inquiryApi = {
  /**
   * Submit an order inquiry
   * Used during checkout from cart
   * 
   * @param {Object} data - Order data
   * @param {string} data.first_name - Customer first name
   * @param {string} data.last_name - Customer last name
   * @param {string} data.email - Customer email
   * @param {string} data.phone - Customer phone
   * @param {string} data.company - Customer company (optional)
   * @param {string} data.message - Order message (optional)
   * @param {Object} data.cart_data - Cart items and total
   * @returns {Promise} Submission result with reference number
   */
  async submitInquiry(data) {
    const response = await apiClient.post(apiEndpoints.inquiries.order, data)
    return response.data
  },

  /**
   * Submit a contact form
   * Used on contact page
   * 
   * @param {Object} data - Contact form data
   * @param {string} data.first_name - First name
   * @param {string} data.last_name - Last name
   * @param {string} data.email - Email address
   * @param {string} data.phone - Phone (optional)
   * @param {string} data.company - Company (optional)
   * @param {string} data.subject - Message subject
   * @param {string} data.message - Message content
   * @returns {Promise} Submission result
   */
  async submitContact(data) {
    const response = await apiClient.post(apiEndpoints.inquiries.contact, data)
    return response.data
  },

  /**
   * Submit a quote request
   * Used on product pages or dedicated quote form
   * 
   * @param {Object} data - Quote request data
   * @param {string} data.first_name - First name
   * @param {string} data.last_name - Last name
   * @param {string} data.email - Email address
   * @param {string} data.phone - Phone (optional)
   * @param {string} data.company - Company (optional)
   * @param {string} data.message - Quote details (optional)
   * @param {Array} data.products - Products of interest (optional)
   * @returns {Promise} Submission result
   */
  async submitQuote(data) {
    const response = await apiClient.post(apiEndpoints.inquiries.quote, data)
    return response.data
  },
}

export default inquiryApi
